import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-left-panel-2-icon',
  templateUrl: './layout-layout-left-panel-2.component.html'
})
export class LayoutLayoutLeftPanel2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
